/**
 * Created by Bart Decorte
 * Date: 2019-04-11
 * Time: 20:25
 */

function renderSelectOptions(data) {
  let html = '';
  data.forEach(x => {
    html += `<option value="${x.value}">${x.name}</option>`;
  });
  return html;
}

function setEnabled(selector, state = true) {
  const $elt = $(selector);
  if (state && $elt.is('[disabled]')) {
    $elt.prop('disabled', false);
  } else if (!state && !$elt.is('[disabled]')) {
    $elt.prop('disabled', true);
  }
}

function getCurrentSelectOptionLabel(selector) {
  const $select = $(selector);
  const currentValue = $select.val();
  const $currentOption = $select.children(`[value="${currentValue}"]`).first();
  return $currentOption.html();
}

function setSelectOptionByLabel(selector, label) {
  const $select = $(selector);
  const $options = $select.children();
  for (let i = 0; i < $options.length; i++) {
    let $option = $($options[i]);
    if ($option.html() == label) {
      $select.val($option.attr('value'));
      return;
    }
  }
}

function setSelectOptionByValue(selector, value) {
  const $select = $(selector);

  // if null, first option
  if (value === null) {
    const $options = $select.children('[value]');
    if ($options.length) {
      value = $($options[0]).attr('value');
    }
  }

  $select.val(value);
}

function setSwitchEnabled(selector, state = true) {
  if (typeof state == 'string') {
    state = parseInt(state);
  }
  let $elt = $(selector);
  let elt = $elt.get(0);

  const inputSelector = 'input[type="checkbox"]';
  if ($elt.is(`:not(${inputSelector})`)) {
    $elt = $elt.find(inputSelector).first();
  }

  $elt.prop('checked', state);

  if (typeof Event === 'function' || !document.fireEvent) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('change', true, true);
    elt.dispatchEvent(event);
  } else {
    elt.fireEvent('onchange');
  }
}

export {
  renderSelectOptions,
  setEnabled,
  setSelectOptionByLabel,
  setSelectOptionByValue,
  getCurrentSelectOptionLabel,
  setSwitchEnabled,
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/form_helper.js